import { render, staticRenderFns } from "./samba-detail.vue?vue&type=template&id=465acb91&"
import script from "./samba-detail.vue?vue&type=script&lang=js&"
export * from "./samba-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports